module.exports = __webpack_public_path__ + "media/packs/images/partners/wog_logo-ea7c3ab03df683721a2c207dd99f22dd.jpg";